<template>

  <el-submenu :index="parentPath">
    <template slot="title">
      <i :class="`iconfont ${parentIcon||'menu'}`" style="color: rgb(191, 203, 217);margin-right: 10px"></i>
      <span>{{ parentTitle }}</span>
    </template>
    <template v-for="(item, index) in children">
      <template v-if="item.children">
        <menu-item :key="index" :parent-item="item"></menu-item>
      </template>
      <template v-else>
        <el-menu-item :index="item.strUrl" :key="index">
          <i :class="`font-color iconfont icon-${item.icon||'menu'}`"></i>
          <span slot="title" style="margin: 0 10px">{{item.strName}}</span>
        </el-menu-item>
      </template>
    </template>
  </el-submenu>

</template>

<script>
export default {
  name: 'menu-item',
  components: {},
  props: {
    parentItem: {
      type: Object,
      default: () => { }
    }
  },
  data () {
    return {
    }
  },
  watch: {},
  computed: {
    parentTitle () {
      return this.parentItem.strName
    },
    parentPath () {
      return this.parentItem.strUrl
    },
    parentIcon () {
      return this.parentItem.icon
    },
    children () {
      return this.parentItem.children
    }
  },
  methods: {},
  created () { 
	  console.log(this.parentItem,56)
  },
  mounted () { }
}
</script>
<style lang="scss" scoped>
  /*.font-color{*/
  /*  margin-right: 0;*/
  /*}*/
</style>
